import { useAppStore } from '../stores';

export const useInvitations = () => {
  const { pending, loading, error, send, accept, reject, clearError } =
    useAppStore((state) => state.invitations);

  return { pending, loading, error, send, accept, reject, clearError };
};
